
import * as types from '../../constants/actionsType'

const initialState = {
  idleTimeList: [],
  activityDataList:[],
  offlineTimeList:[],
  getAgentConfiguration:[],
  isLoading:false
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AGENTCONFIGURATION_LOADING:
      return{
        ...state,
        isLoading:action.data
      }
    case types.GET_AGENTCONFIGURATION:
      return {
        ...state,
        idleTimeList: action.data.list.idleMinList,
        offlineTimeList:action.data.list.offlineTimeList,
        activityDataList:action.data.list.minTimeList,
        getAgentConfiguration:action.data.list.configurationList[0],
      }
      case types.EMPTY_AGENTCONFIGURATION:
        return {
          ...state,
          idleTimeList: [],
          offlineTimeList:[],
          activityDataList:[],
          getAgentConfiguration:[],
        }
    default:
      return state
  }
}
export default reducer
